var addToCart = {
	init:function(){
		$( '.single_add_to_cart_button' ).on( 'click', function(e) {
			e.preventDefault();
			const $thisbutton = $(e.target);
			const $form = $thisbutton.closest('form.cart');
			const id = $thisbutton.val();
			const productQty = $form.find('input[name=quantity]').val() || 1;
			const productId = $form.find('input[name=product_id]').val() || id;
			const variationId = $form.find('input[name=variation_id]').val() || 0;

			const data = {
				action: 'ajax_add_to_cart',
				product_id: productId,
				product_sku: '',
				quantity: productQty,
				variation_id: variationId,
			};
			$(document.body).trigger('adding_to_cart', [$thisbutton, data]);

			$.ajax({
				type: 'post',
				url: woocommerce_params.ajax_url,
				data: {
					action: 'ajax_add_to_cart',
					product_id: productId,
					product_sku: '',
					quantity: productQty,
					variation_id: variationId,
				},
				beforeSend: function(){
					$thisbutton.removeClass('added').addClass('loading');
				},
				complete:  function(){
					$thisbutton.addClass('added').removeClass('loading');
				},
				success: function(response) {

					if (response.error && response.product_url) {
						window.location = response.product_url;
					} else {
						$(document.body).trigger('added_to_cart', [response.fragments, response.cart_hash, $thisbutton]);
						MiniCart.open_cart();
					}

				},
			});
		});
	},



	changeQuantity: function() {
		$(document).on('click', '.mini-cart .change-quantity', function(e) {
			e.preventDefault();
			const qty = $( e.target ).parent( '.Quantity' ).find( '.qty' );
			const valQty = parseFloat(qty.val());
			const max = parseFloat(qty.attr( 'max' ));
			const min = parseFloat(qty.attr( 'min' ));
			const step = parseFloat(qty.attr( 'step' ));

			if ( 'plus' === $(e.target).data('change') ) {
				if ( valQty >= max  ) {
					qty.val( max );
				} else {
					qty.val( valQty + step );
				}
			}
			if ( 'minus' === $(e.target).data('change') ){
				if ( valQty  <= min ) {
					qty.val( min );
				} else {
					qty.val( valQty - step );
				}
			}
			qty.trigger('change');
		});

		$(document).on('change', '.mini-cart input.qty', function(e) {
			const itemHash = $( e.target ).attr( 'name' ).replace(/cart\[([\w]+)\]\[qty\]/g, "$1");
			const itemQuantity = $( e.target ).val();
			const currentVal = parseFloat(itemQuantity);
			$.ajax({
				type: 'post',
				url: woocommerce_params.ajax_url,
				data: {
					action: 'qty_cart',
					hash: itemHash,
					quantity: currentVal
				},
				beforeSend : function() {
					$('.loader').addClass('show');
				},
				success: function(response) {
					$('.loader').removeClass('show');
					if (response.error && response.product_url) {
						window.location = response.product_url;
					} else {
						$(document.body).trigger('added_to_cart', [response.fragments, response.cart_hash]);
					}
				},
			});
		});

		$(document).on('click', '.woocommerce-cart .change-quantity', function(e) {
			e.preventDefault();
			const qty = $( e.target ).parent( '.Quantity' ).find( '.qty' );
			const valQty = parseFloat(qty.val());
			const max = parseFloat(qty.attr( 'max' ));
			const min = parseFloat(qty.attr( 'min' ));
			const step = parseFloat(qty.attr( 'step' ));

			if ( 'plus' === $(e.target).data('change') ) {
				if ( valQty >= max  ) {
					qty.val( max );
				} else {
					qty.val( valQty + step );
				}
			}
			if ( 'minus' === $(e.target).data('change') ){
				if ( valQty  <= min ) {
					qty.val( min );
				} else {
					qty.val( valQty - step );
				}
			}
			qty.trigger('change');
		});
	},
	removeFromCart : function(){
		$( document ).on( 'click', '.product-remove', function(e){
			e.preventDefault();
			const $thisbutton = $(e.target);
			const productId = $thisbutton.data('product_id');
			const cartItemKey = $thisbutton.data('cart_item_key');
			$.ajax({
				type: 'post',
				url: woocommerce_params.ajax_url,
				data: {
					action: 'remove_from_cart',
					product_id: productId,
					cart_item_key: cartItemKey
				},
				beforeSend: function(){
					$('.loader').addClass('show');
				},
				success: function(response){
					$('.loader').removeClass('show');
					$(document.body).trigger('added_to_cart', [response.fragments, response.cart_hash]);
					/*MiniCart.close_cart();*/
				},
			});
		});
	}

};

$(window).load(function(){
	if($(".single_add_to_cart_button").length){
		addToCart.init();
	}
	addToCart.changeQuantity();
	addToCart.removeFromCart();
});





